// eslint-disable-next-line import/no-cycle
import { ConfigurationPanelStructureItemEnum, FieldsGroup } from '@/types';
// eslint-disable-next-line import/no-cycle
import getConditionalDisplayField from '@/components/template-builder/config/fields/conditional-display-field-helper';
// eslint-disable-next-line import/no-cycle
import getLoopField from '@/components/template-builder/config/fields/loop-field-helper';

/**
 * Get conditions and repetition fields group configuration
 * Creates a dedicated accordion for conditional display and/or loop fields
 * @param selector - CSS selector for the element (use #{ID} for widget ID)
 * @param options - Optional configuration { includeConditions?: boolean, includeLoop?: boolean }
 * @returns Fields group configuration object
 */
const getConditionsAndRepetitionGroup = (
  selector: string,
  options: { includeConditions?: boolean; includeLoop?: boolean } = {},
): FieldsGroup => {
  const { includeConditions = true, includeLoop = true } = options;

  const items = [];
  if (includeConditions) {
    items.push(getConditionalDisplayField(selector));
  }
  if (includeLoop) {
    items.push(getLoopField(selector));
  }

  // Determine label based on active features
  let label = 'templateBuilder.configs.conditionsAndRepetition';
  if (includeConditions && !includeLoop) {
    label = 'templateBuilder.configs.conditions';
  } else if (!includeConditions && includeLoop) {
    label = 'templateBuilder.configs.repetition';
  }

  return {
    type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
    label,
    items,
  };
};

export default getConditionsAndRepetitionGroup;
